import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CREATE_OR_UPDATE_ABSATZ_PLANWERT_AND_INTERNE_NOTIZ } from './graphql/mutations';
import {
  CreateOrUpdateAbsatzPlanWertAndInterneNotizMutation,
  CreateOrUpdateAbsatzPlanWertAndInterneNotizMutationVariables,
} from '@/gql/graphql';

export function useAbsatzPlanWertCreateOrUpdate() {
  const [execute, result] = useMutation<
    CreateOrUpdateAbsatzPlanWertAndInterneNotizMutation,
    CreateOrUpdateAbsatzPlanWertAndInterneNotizMutationVariables
  >(CREATE_OR_UPDATE_ABSATZ_PLANWERT_AND_INTERNE_NOTIZ, {
    refetchQueries: [
      'getPlanwerteByStandortId',
      'getHistorie',
      'getTagebuchEintraegeByStandortIds',
    ],
  });

  const createOrUpdateAbsatzPlanWert = useCallback(
    (
      variables: CreateOrUpdateAbsatzPlanWertAndInterneNotizMutationVariables,
    ) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createOrUpdateAbsatzPlanWert, result] as const;
}
